/**
 *
 * @component   施工进度/验收报告/ 通过和未通过
 *
 **/
import { memo } from 'react';
import './CheckStatus.scss';

function CheckStatus(props) {
    const { isPass = true } = props;

    const calcContent = ({ image, text }) => {
        return (
            <>
                <img
                    draggable={false}
                    className="status-img"
                    src={
                        require(`@/assets/img/userCenter/${image}.png`).default
                    }
                    alt=""
                />
                <div className="status-text">{text}</div>
            </>
        );
    };

    const pass = {
        image: 'success',
        text: intl.get('projectSpace.pass'),
    };

    const not = {
        image: 'fail',
        text: intl.get('projectSpace.notPass'),
    };

    return <div className="form-group">{calcContent(isPass ? pass : not)}</div>;
}

export default memo(CheckStatus);
